import Service from "../abstract/service";

export default class Usuarios extends Service {
  constructor() {
    super();
    this._usuariosCollection = this._db.collection(`Usuarios`);
  }

  mountQuery(params = {}) {
    let query = this._usuariosCollection;

    // Se não vier nada, retorna a collection inteira
    if (!params || typeof params !== "object") return query;

    Object.entries(params).forEach(([key, value]) => {
      // Ignora null/undefined
      if (value === undefined || value === null) return;

      // CPF: remove máscara e força string só com números
      if (key === "cpf") {
        const cpfLimpo = String(value).replace(/[^0-9]/g, "");
        if (!cpfLimpo) return; // se ficar vazio, ignora
        query = query.where("cpf", "==", cpfLimpo);
        return;
      }

      // Strings vazias não entram na query
      if (typeof value === "string" && value.trim() === "") return;

      // Se for array, usa "in", se não, usa "=="
      if (Array.isArray(value)) {
        if (value.length === 0) return;
        // cuidado: Firestore só permite até 10 itens em "in"
        query = query.where(key, "in", value);
      } else {
        query = query.where(key, "==", value);
      }
    });

    return query;
  }

  async list(params) {
    const usuariosArr = [];
    const query = this.mountQuery(params);

    const data = await query.get();

    for (let usuarioDoc of data.docs) {
      usuariosArr.push({
        id: usuarioDoc.id,
        ...usuarioDoc.data()
      });
    }

    return usuariosArr; // não precisa de Promise.resolve
  }

  async update(usuario) {
    try {
      let usuarioRef = this._usuariosCollection.doc(usuario.id);
      await usuarioRef.update({
        nome: usuario.nome,
        apelido: usuario.apelido,
        telefone: usuario.telefone,
        papel: usuario.papel,
        prefix: usuario.prefix
      });
    } catch (error) {
      return Promise.reject(error);
    }

    return "Usuário atualizado com sucesso!";
  }

  async updateEmpresaGrupo(usuario) {
    try {
      let usuarioRef = this._usuariosCollection.doc(usuario.id);
      await usuarioRef.update({
        empresaPrincipal: usuario.empresaPrincipal,
        grupoPrincipal: usuario.grupoPrincipal,
        papel: usuario.papel
      });
    } catch (error) {
      return Promise.reject(error);
    }

    return "Usuário atualizado com sucesso!";
  }

  async getUsuarioByCpf(cpf) {
    try {
      let usuario = await this._usuariosCollection.doc(cpf).get();
      return usuario.exists ? usuario.data() : null;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  async delete(cpf) {
    try {
      await this._usuariosCollection.doc(cpf).delete();
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
